module.exports = __webpack_public_path__ + "Step5_Header_new.1e459d8b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/mobile/headers/Step5_Header_new.png
// module id = rFIv
// module chunks = 0